import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import {
	APP_PREFIX_PATH,
	AUTH_PREFIX_PATH,
	CONVITE_PREFIX_PATH,
	REGISTRO_PREFIX_PATH,
	REGISTRO_ESPECIAL_LIVE_PREFIX_PATH,
	DARKSIDE_PREFIX_PATH,
	ANIVERSARIO_PREFIX_PATH,
	CONDICAO_UNICA_PREFIX_PATH,
	TERMOS_PREFIX_PATH,
} from "configs/AppConfig";
import DeeplinkRedirect from "./deeplink-redirect";
import GrupoLiveRedirect from "./redirect-views/GrupoLiveRedirect";
import useBodyClass from "hooks/useBodyClass";
import Loading from "components/atom/Loading/Loading";
import ConviteLayout from "layouts/convite-layout";
import RegistroLayout from "layouts/registro-layout";
import RegistroEspecialLiveLayout from "layouts/registro-especial-live-layout";
import DarksideLayout from "layouts/darkside-layout";
import AniversarioLayout from "layouts/aniversario-layout";
import CondicaoUnicaLayout from "layouts/condicao-unica-layout";
import TermosLayout from "layouts/termos-layout";
import CheckoutLayout from "layouts/checkout-layout";

function RouteInterceptor({ children, isAuthenticated, ...rest }) {
	return (
		<Route
			{...rest}
			render={({ location }) =>
				isAuthenticated ? (
					children
				) : (
					<Redirect
						to={{
							pathname: `${AUTH_PREFIX_PATH}/login`,
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}

export const Views = (props) => {
	const { locale, token, location, direction } = props;
	const currentAppLocale = AppLocale[locale];
	useBodyClass(`dir-${direction}`);
	return (
		<IntlProvider
			locale={currentAppLocale.locale}
			messages={currentAppLocale.messages}
		>
			<Loading />
			<ConfigProvider
				locale={currentAppLocale.antd}
				direction={direction}
				theme={{
					components: {
						Menu: {
							padding: 10,
						},
						Button: {
							colorPrimary: "#000",
						},
					},
					Menu: {
						padding: 60,
					},
				}}
			>
				<Switch>
					<Route exact path="/">
						<Redirect to={APP_PREFIX_PATH} />
					</Route>
					<Route path="/deeplink">
						<DeeplinkRedirect />
					</Route>
					<Route path="/grupo-live/:idUsuario?">
						<GrupoLiveRedirect />
					</Route>
					<Route path={AUTH_PREFIX_PATH}>
						<AuthLayout direction={direction} />
					</Route>
					<Route path={CONVITE_PREFIX_PATH}>
						<ConviteLayout direction={direction} />
					</Route>
					<Route path={REGISTRO_ESPECIAL_LIVE_PREFIX_PATH}>
						<RegistroEspecialLiveLayout direction={direction} />
					</Route>
					<Route path={REGISTRO_PREFIX_PATH}>
						<RegistroLayout direction={direction} />
					</Route>
					<Route path={DARKSIDE_PREFIX_PATH}>
						<DarksideLayout direction={direction} />
					</Route>
					<Route path={ANIVERSARIO_PREFIX_PATH}>
						<AniversarioLayout direction={direction} />
					</Route>
					<Route path={CONDICAO_UNICA_PREFIX_PATH}>
						<CondicaoUnicaLayout direction={direction} />
					</Route>
					<Route path={TERMOS_PREFIX_PATH}>
						<TermosLayout direction={direction} />
					</Route>
					<Route path={["/checkout-oferta", "/checkout"]}>
						<CheckoutLayout direction={direction} />
					</Route>
					<RouteInterceptor
						path={APP_PREFIX_PATH}
						isAuthenticated={token}
					>
						<AppLayout direction={direction} location={location} />
					</RouteInterceptor>
				</Switch>
			</ConfigProvider>
		</IntlProvider>
	);
};

const mapStateToProps = ({ theme, auth }) => {
	const { locale, direction } = theme;
	const { token } = auth;
	return { locale, token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
